module.exports = __webpack_public_path__ + "static/media/platforms-ios.2fecc3c5.svg";